const ListConstants = {
  TABLE_HEADER_HEIGHT: 140,
};

export default ListConstants;
